import { render, staticRenderFns } from "./ReporteEmisionVida.vue?vue&type=template&id=18d8a904"
import script from "./ReporteEmisionVida.vue?vue&type=script&lang=js"
export * from "./ReporteEmisionVida.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports